export const timezonesList = [
    { title: "UTC-10 (Honolulu)", id: "-10" },
    { title: "UTC-9 (Anchorage, Fairbanks)", id: "-9" },
    { title: "UTC-8 (Los Angeles, San Francisco, Las Vegas)", id: "-8" },
    { title: "UTC-7 (Denver, Phoenix, Calgary)", id: "-7" },
    { title: "UTC-6 (Houston, New Orleans, Mexico City)", id: "-6" },
    { title: "UTC-5 (New York, Boston, Atlanta)", id: "-5" },
    { title: "UTC-4 (Georgetown, Caracas)", id: "-4" },
    { title: "UTC-3 (Rio de Janeiro, Santiago, Baghdad)", id: "-3" },
    { title: "UTC-1 (Azores, Cabo Verde)", id: "-1" },
    { title: "UTC+0 (London, Dublin, Timbuktu)", id: "0" },
    { title: "UTC+1 (Berlin, Oslo, Paris)", id: "1" },
    { title: "UTC+2 (Kyiv, Riga, Sofia)", id: "2" },
    { title: "UTC+3 (Ankara, Baghdad, Moscow)", id: "3" },
    { title: "UTC+4 (Abu Dhabi, Baku, Tbilisi)", id: "4" },
    { title: "UTC+5 (Tashkent, Islamabad, Ashgabat )", id: "5" },
    { title: "UTC+6 (Almaty, Bishkek, Dhaka)", id: "6" },
    { title: "UTC+7 (Hanoi, Vientiane, Phnom Penh)", id: "7" },
    { title: "UTC+8 (Beijing, Irkutsk, Ulaanbaatar)", id: "8" },
    { title: "UTC+9 (Seoul, Dili, Osaka)", id: "9" },
    { title: "UTC+10 (Queensland, Guam)", id: "10" },
    { title: "UTC+11 (Melbourne, Yuzhno-Sakhalinsk)", id: "11" },
    { title: "UTC+12 (Auckland, Petropavlovsk-Kamchatsky)", id: "12" }
]